import React, { useState } from "react";
import moment from "moment";
import Modal from "react-modal";
import ReactPlayer from "react-player";
import "./RemarksRoadmap.css"; // Import CSS file for styling
import { API_URL } from "..";



const RemarksRoadmap = ({ remarks }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedAttachment, setSelectedAttachment] = useState(null);

  const openAttachment = (attachment) => {
    setSelectedAttachment(attachment);
    setModalIsOpen(true);
  };

  const closeAttachment = () => {
    setModalIsOpen(false);
    setSelectedAttachment(null);
  };

  return (
    <div className="roadmap-container">
      {remarks.map((remark, index) => {
        const timeAgo = moment(remark.createdAt).fromNow();

        return (
          <div key={remark.id} className="remark-item">
            {/* Timeline Line */}
            {index !== 0 && <div className="timeline-line"></div>}

            {/* Circle Indicator */}
            <div className="timeline-circle"></div>

            {/* Remark Content */}
            <div className="remark-content">
              <h3 className="remark-title">{remark.title}</h3>
              <p className="remark-description">{remark.description}</p>

              {/* User Info */}
              <p className="remark-user">
                {remark.electrician?.name} ({remark.user_type})
              </p>
              <p className="remark-contact">{remark.electrician?.phone}</p>
              <p className="remark-time">{timeAgo}</p>

              {/* Attachments */}
              {remark.attachments && JSON.parse(remark.attachments).length > 0 && (
                <div className="attachments-container">
                  {JSON.parse(remark.attachments).map((attachment, idx) => {
                    const fullAttachmentPath = `${API_URL}${attachment}`;
                    const isVideo = attachment.endsWith(".mp4");

                    return (
                      <div key={idx} className="attachment-item" onClick={() => openAttachment(fullAttachmentPath)}>
                        {isVideo ? (
                          <ReactPlayer url={fullAttachmentPath} width="100px" height="80px" light={true} />
                        ) : (
                          <img src={fullAttachmentPath} alt="attachment" className="attachment-image" />
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        );
      })}

      {/* Full-Screen Modal for Image/Video Preview */}
      <Modal isOpen={modalIsOpen} onRequestClose={closeAttachment} className="modal-content" overlayClassName="modal-overlay">
        <button className="close-button" onClick={closeAttachment}>Close</button>

        {selectedAttachment && selectedAttachment.endsWith(".mp4") ? (
          <ReactPlayer url={selectedAttachment} controls width="80%" height="70vh" />
        ) : (
          <img src={selectedAttachment} style={{objectFit:'contain'}} alt="Full View" className="full-screen-image" />
        )}
      </Modal>
    </div>
  );
};



export default RemarksRoadmap;
